<script setup lang="ts">
withDefaults(defineProps<{
  showPlayIcon: boolean,
  showDownloadIcon: boolean,
  showGalleryIcon: boolean,
  variant?: 'image' | 'content'
}>(), {
  variant: 'image'
})
</script>

<template>
  <svg v-if="showPlayIcon"
       class="bx-badge bx-badge--play icon icon-play">
    <use href="#play" />
  </svg>
  <svg v-if="showDownloadIcon"
       class="bx-badge bx-badge--download icon icon-download"
       :class="{ 'bx-badge--over-content': variant === 'content' }">
    <use href="#download" />
  </svg>
  <svg v-if="showGalleryIcon"
       class="bx-badge bx-badge--gallery icon icon-gallery"
       :class="{ 'bx-badge--over-content': variant === 'content' }">
    <use href="#gallery" />
  </svg>
</template>
